<div class="grid">
    <div class="col-12 lg:col-6 xl:col-3">
        <div class="card mb-0">
            <div class="flex justify-between mb-1">
                <div>
                    <span class="block text-muted-color font-medium mb-1">Orders</span>
                    <div class="text-surface-900 dark:text-surface-0 font-medium text-xl"><span *ngIf="!isSalesLoading">
                            {{orderCount}}</span>
                        <i *ngIf="isSalesLoading" class="pi pi-spin pi-spinner"></i>
                    </div>
                    <div>
                        <!-- <span class="text-green-500 font-medium">$ {{perOrderIncome|number:'1.2-2'}} </span>
                        <span class="text-500"> Revenue per Order</span> -->
                    </div>
                </div>
                <!-- <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border" style="width: 2.5rem; height: 2.5rem">
                    <i class="pi pi-shopping-cart text-blue-500 !text-xl"></i>
                </div> -->
                <div [ngStyle]="{width: '5.5rem'}">
                    <p-chart type="doughnut" [data]="orderCountsPieData" [options]="douhnutOptions"></p-chart>
                </div>
            </div>
            <span class="text-green-500 font-medium">$ {{perOrderIncome|number:'1.2-2'}} </span>
            <span class="text-muted-color"> Revenue per Order</span>
            <!-- <span class="text-primary font-medium">24 new </span>
            <span class="text-muted-color">since last visit</span> -->
        </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-3">
        <div class="card mb-0">
            <div class="flex justify-between mb-1">
                <div>
                    <span class="block text-muted-color font-medium mb-1">Items Sold</span>
                    <div class="text-surface-900 dark:text-surface-0 font-medium text-xl"><span
                            *ngIf="!isSalesLoading">{{itemCount}} </span><i *ngIf="isSalesLoading"
                            class="pi pi-spin pi-spinner"></i>
                    </div>
                </div>
                <div [ngStyle]="{width: '5.5rem'}">
                    <p-chart type="doughnut" [data]="itemCountsPieData" [options]="douhnutOptions"></p-chart>
                </div>
                <!-- <div class="flex items-center justify-center bg-orange-100 dark:bg-orange-400/10 rounded-border"
                    style="width: 2.5rem; height: 2.5rem">
                    <i class="pi pi-dollar text-orange-500 !text-xl"></i>
                </div> -->
            </div>
            <!-- <span class="text-primary font-medium">%52+ </span>
            <span class="text-muted-color">since last week</span> -->
            <span class="text-green-500 font-medium">$ {{perItemProfit|number:'1.2-2'}} </span>
            <span class="text-muted-color">Profit per Item</span>
        </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-3">
        <div class="card mb-0">
            <div class="flex justify-between mb-1">
                <div>
                    <span class="block text-muted-color font-medium mb-1">Revenue</span>
                    <div class="text-surface-900 dark:text-surface-0 font-medium text-xl"><span *ngIf="!isSalesLoading">$
                            {{income|number:'1.0-0'}} </span><i *ngIf="isSalesLoading" class="pi pi-spin pi-spinner"></i>
                    </div>
                </div>
                <div [ngStyle]="{width: '5.5rem'}">
                    <p-chart type="doughnut" [data]="incomeListPieData" [options]="douhnutOptions"></p-chart>
                </div>
                <!-- <div class="flex items-center justify-center bg-cyan-100 dark:bg-cyan-400/10 rounded-border"
                    style="width: 2.5rem; height: 2.5rem">
                    <i class="pi pi-users text-cyan-500 !text-xl"></i>
                </div> -->
            </div>
            <span class="text-green-500 font-medium"> $ {{perItemIncome|number:'1.2-2'}} </span>
            <span class="text-muted-color">per Item</span>
            <!-- <span class="text-primary font-medium">520 </span>
            <span class="text-muted-color">newly registered</span> -->
        </div>
    </div>
    <div class="col-12 lg:col-6 xl:col-3">
        <div class="card mb-0">
            <div class="flex justify-between mb-1">
                <div>
                    <span class="block text-muted-color font-medium mb-1">Profit</span>
                    <div class="text-surface-900 dark:text-surface-0 font-medium text-xl"><span *ngIf="!isSalesLoading">
                            $ {{profit|number:'1.0-0'}} </span><i *ngIf="isSalesLoading" class="pi pi-spin pi-spinner"></i>
                    </div>
                </div>
                <div [ngStyle]="{width: '5.5rem'}">
                    <p-chart type="doughnut" [data]="profitListPieData" [options]="douhnutOptions"></p-chart>
                </div>
                <!-- <div class="flex items-center justify-center bg-purple-100 dark:bg-purple-400/10 rounded-border"
                    style="width: 2.5rem; height: 2.5rem">
                    <i class="pi pi-comment text-purple-500 !text-xl"></i>
                </div> -->
            </div>
            <span class="text-green-500 font-medium">$ {{perOrderProfit|number:'1.2-2'}} </span>
            <span class="text-muted-color">per Order</span>
            <!-- <span class="text-primary font-medium">85 </span>
            <span class="text-muted-color">responded</span> -->
        </div>
    </div>
</div>